module.exports = __webpack_public_path__ + "images/emoji/white_medium_small_square.03fc7a850bffd86330fe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_medium_small_square.png
// module id = RRyz
// module chunks = 24